import { buildChartOptions } from '@configurations/campaignAnalytics/proximityToHomeChart';
import Highcharts from 'highcharts';
import HighchartsReact from 'highcharts-react-official';
import { ChartCard } from '../ChartCard';
import { EditableChartProps } from './chartProps';
import { sortBy } from '@utils/arrays';

type ProximityToHomeProps = EditableChartProps;

const ProximityToHome = (props: ProximityToHomeProps) => {
  const { report, ...chartCardProps } = props;

  return (
    <ChartCard
      title="Proximity to Home"
      description={`${props.campaignName} (${props.campaignId})`}
      report={report.proximityToHome}
      {...chartCardProps}
    >
      <HighchartsReact
        highcharts={Highcharts}
        options={buildChartOptions(
          report.proximityToHome.data.toSorted(sortBy('sortIndex', 'asc'))
        )}
      />
    </ChartCard>
  );
};

export default ProximityToHome;
